module.exports = __webpack_public_path__ + "static/media/intro-1.6caec120.svg";